const myEmitAndOn = () => {
  const map = {}
  function myEmit(name,params){
    if(map[name]==null){
      console.log("没有找到关于"+name+"的事件，无法触发")
    }else{
        map[name].detail=params;
        window.dispatchEvent(map[name]);
    }
  }
  function myOn(name,work){
    let myEvent = new Event(name);
    map[name]=myEvent;
    window.addEventListener(name, ()=>{
        // console.log('得到数据为：', e.detail);
        work(map[name].detail);
    });
  }
  return {
    map,
    $myEmit: myEmit,
    $myOn: myOn
  }
}
export default myEmitAndOn()